import * as R from 'ramda';
import { ValidatorUtils } from './utils';

export const alphanumericWithSpacesValidator = {
    validate: (value: any) => {
        if (R.isNil(value) || R.isEmpty(value)) {
            return {
                valid: false,
            };
        }
        return {
            valid: /^[a-z0-9 ]+$/i.test(value),
        };
    },
    message(field: string) {
        return `'${ValidatorUtils.prettifyName(field)}' should include only alphanumeric characters and spaces.`;
    },
};
